import { DetailProductGuildInfo } from "../type";
import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
const DetailGuildTab = (prop: DetailProductGuildInfo) => {
    const videoDropDown: MenuProps['items'] = prop.video.language.map(lang => ({
        key: lang.name,
        label: (
            <a href={lang.url || '#'} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 !no-underline">
                {lang.icon} {lang.name}
            </a>
        ),
    }));

    const documentDropDown: MenuProps['items'] = prop.document.language.map(lang => ({
        key: lang.name,
        label: (
            <a href={lang.url || '#'} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 !no-underline">
                {lang.icon} {lang.name}
            </a>
        ),
    }));

    return (
        <div className="p-6 space-y-4">
            {prop.video.language.length > 0 &&
                <div className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition duration-200">
                    <div className="flex items-start gap-4">
                        <div className="p-3 bg-red-100 rounded-lg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-play h-6 w-6 text-red-600"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
                        </div>
                        <div className="flex-1">
                            <h3 className="font-semibold text-gray-900 mb-2">Detailed Instructional Video</h3>
                            <p className="text-gray-600 mb-3">
                                Step-by-step video guide on how to install, configure, and use the bot most effectively. Includes tips and tricks from experts.
                            </p>
                            <div className="flex items-start gap-4 text-sm text-gray-500 mb-3">
                                <span>⏱️ Duration: {prop.video.duration}</span>
                                <span>🎯 Difficulty: {prop.video.difficulty}</span>
                            </div>
                            <div className="flex items-start gap-2 text-sm text-gray-500 mb-3">
                                <div>
                                    🌐 Language:
                                </div>
                                <div className="flex items-center gap-2">
                                    {prop.video.language.map((lang) => (
                                        <div key={lang.name} className="ml-1">
                                            {lang.icon} {lang.name}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <Dropdown menu={{ items: videoDropDown }} trigger={['click']}>
                                <button className="inline-flex items-center gap-2 !bg-red-600 !text-white px-4 py-2 !rounded-lg hover:!bg-red-700 transition duration-200">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-play h-4 w-4"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
                                    Watch video on YouTube | <DownOutlined />
                                </button>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            }
            {
                prop.document.language.length > 0 &&
                <div className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition duration-200">
                    <div className="flex items-start gap-4">
                        <div className="p-3 bg-blue-100 rounded-lg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-text h-6 w-6 text-blue-600"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
                        </div>
                        <div className="flex-1">
                            <h3 className="font-semibold text-gray-900 mb-2">PDF Instruction Manual</h3>
                            <p className="text-gray-600 mb-3">Detailed written guide with illustrative images, including:</p>
                            <ul className="text-gray-600 space-y-1 mb-3">
                                <li>• How to install the bot on the platform</li>
                                <li>• Optimal parameter configuration</li>
                                <li>• Risk management and money management</li>
                                <li>• Troubleshooting common errors</li>
                                <li>• FAQ and technical support</li>
                            </ul>
                            <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                                <span>📄 {prop.document.totalPages} Page</span>
                                <span>🖼️ Includes illustrative images</span>
                            </div>
                            <div className="flex items-start gap-2 text-sm text-gray-500 mb-3">
                                <div>
                                    🌐 Language:
                                </div>
                                <div className="flex items-center gap-2">
                                    {prop.document.language.map((lang) => (
                                        <div key={lang.name} className="ml-1">
                                            {lang.icon} {lang.name}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <Dropdown menu={{ items: documentDropDown }} trigger={['click']}>
                                <button className="inline-flex items-center gap-2 !bg-blue-600 !text-white px-4 py-2 !rounded-lg hover:!bg-blue-700 transition duration-200">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-download h-4 w-4"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" x2="12" y1="15" y2="3"></line></svg>
                                    Download PDF manual | <DownOutlined />
                                </button>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            }
            <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 mb-2">🎓 Additional Support</h4>
                <p className="text-gray-600 mb-3">After purchasing the bot, you will join a private Telegram/Discord group to:</p>
                <ul className="text-gray-600 space-y-1">
                    <li>• Receive 1-on-1 technical support</li>
                    <li>• Get new version updates</li>
                    <li>• Share experiences with the community</li>
                    <li>• Receive optimal settings for each market period</li>
                </ul>
            </div>
        </div>
    )
};

export default DetailGuildTab;